import React from 'react'
import LunchItems from '../Allmenus/FirstMenu/LunchItems';
import Bredcom from '../Bredcrumb/Main'
import Img from '../../assets/images/background/banner-image-6.jpg'

function LunchMenu() {
  return (
    <>
      <Bredcom subtitle="Lunch Menu" title="FRESH & AMAZING" Img={Img} />
      <LunchItems />
    </>
  )
}

export default LunchMenu